import { FilterOperation } from '@/types/search';

export const genSearchFilterFor = (searchTerm: string, fields: string[]) => {
  if (!searchTerm) return {};
  return {
    search: {
      value: JSON.stringify(
        fields.map((field) => ({
          field,
          value: searchTerm,
          operation: FilterOperation.CONTAINS,
        }))
      ),
      operation: FilterOperation.OR,
    },
  };
};
